(() => {
  if (window.__eantasUpcartGwp) return;
  window.__eantasUpcartGwp = true;

  const BANNER_ID = 'eantas-upcart-gwp';
  const STYLE_ID = 'eantas-upcart-gwp-style';
  const EMPTY_SELECTOR = '[class*="CartPreview__empty"]';
  const HANDLE_PYJAMA = /pyjama/i;
  const HANDLE_GIFT = /sleep-mask|schlafmask/i;

  const configEl = document.getElementById('eantas-upcart-gwp-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  const pyjamaIds = new Set((config.pyjamaIds || []).map(String));
  const giftProductId = String(config.giftProductId || '');
  let lastPyjamaQty = null;
  let lastOffer = null;
  let refreshTimer = 0;
  let syncing = false;
  let collectionIdsLoaded = false;
  let cssText = '';
  let drawerObserver = null;
  let observedHost = null;

  function readCssText() {
    if (cssText) return cssText;
    const sheets = document.querySelectorAll('link[href*="upcart-sleep-mask-gwp"]');
    if (!sheets.length) return '';
    try {
      const sheet = sheets[0].sheet;
      if (!sheet) return '';
      cssText = Array.from(sheet.cssRules).map((rule) => rule.cssText).join('\n');
    } catch (error) {
      cssText = '';
    }
    return cssText;
  }

  function itemProductId(item) {
    return String(item.product_id || item.productId || '');
  }

  function itemHandle(item) {
    return String(item.handle || '').toLowerCase();
  }

  function itemQuantity(item) {
    const qty = Number(item.quantity);
    return Number.isFinite(qty) ? qty : 0;
  }

  function isGiftItem(item) {
    const id = itemProductId(item);
    if (id && id === giftProductId) return true;
    return HANDLE_GIFT.test(itemHandle(item));
  }

  function isPyjamaItem(item) {
    if (isGiftItem(item)) return false;
    const id = itemProductId(item);
    if (id && pyjamaIds.has(id)) return true;
    return HANDLE_PYJAMA.test(itemHandle(item));
  }

  function countPyjamas(items) {
    return (items || []).reduce((sum, item) => (
      isPyjamaItem(item) ? sum + itemQuantity(item) : sum
    ), 0);
  }

  function cartItems(cart) {
    if (!cart) return [];
    return cart.items || cart.lineItems || [];
  }

  function getSearchRoots() {
    const roots = [];
    const seen = new Set();

    function add(root) {
      if (!root || seen.has(root)) return;
      seen.add(root);
      roots.push(root);
    }

    const host = document.getElementById('upCart');
    add(host);
    if (host && host.shadowRoot) add(host.shadowRoot);

    const upcartDoc = window.upcartDocument;
    if (upcartDoc && upcartDoc !== document && upcartDoc.getElementById) {
      const iframeHost = upcartDoc.getElementById('upCart') || upcartDoc.getElementById('CartPopup');
      add(iframeHost);
      if (iframeHost && iframeHost.shadowRoot) add(iframeHost.shadowRoot);
    }

    return roots;
  }

  function ownerDocument(node) {
    return node && node.ownerDocument ? node.ownerDocument : document;
  }

  function ensureShadowStyles(root) {
    if (!root || root === document || root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.getElementById && root.getElementById(STYLE_ID)) return;
    const text = readCssText();
    if (!text) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = text;
    root.appendChild(style);
  }

  function findHeader(root) {
    return root.querySelector('.upcart-header')
      || root.querySelector('[class*="CartPreview"] [class*="Header__"]');
  }

  function findMount(root) {
    const header = findHeader(root);
    if (!header || !header.parentNode) return null;
    const empty = root.querySelector(EMPTY_SELECTOR);
    if (empty) {
      const rect = empty.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return null;
    }
    return header;
  }

  function nextTier(qty) {
    if (qty < 1) return null;
    if (qty === 1) {
      return { kind: 'gift', message: config.messageGift || config.message || '', showGift: true };
    }
    if (qty >= 6) return null;

    let percent = 15;
    let at = 3;
    if (qty >= 4) {
      percent = 30;
      at = 6;
    } else if (qty >= 3) {
      percent = 20;
      at = 4;
    }

    const need = at - qty;
    const template = need === 1
      ? (config.messageNextOne || '')
      : (config.messageNextMany || '');
    const message = template
      .replace(/PERCENT/g, String(percent))
      .replace(/COUNT/g, String(need))
      .replace(/\{\{\s*percent\s*\}\}/g, String(percent))
      .replace(/\{\{\s*count\s*\}\}/g, String(need));

    return { kind: 'plus', message, showGift: false };
  }

  function offerKey(offer) {
    if (!offer) return '';
    return `${offer.kind}:${offer.message}`;
  }

  function buildBanner(doc, offer) {
    const banner = doc.createElement('a');
    banner.id = BANNER_ID;
    banner.className = 'eantas-upcart-gwp';
    if (offer.kind === 'plus') banner.classList.add('eantas-upcart-gwp--plus');
    banner.href = config.collectionUrl || '/collections/schlafkollektion';
    banner.setAttribute('data-eantas-gwp', '1');
    banner.dataset.offerKey = offerKey(offer);
    banner.setAttribute('aria-label', `${offer.message || ''} ${config.cta || ''}`.trim());

    if (offer.showGift && config.giftImage) {
      const media = doc.createElement('span');
      media.className = 'eantas-upcart-gwp__media';

      const image = doc.createElement('img');
      image.className = 'eantas-upcart-gwp__image';
      image.src = config.giftImage;
      image.alt = config.giftAlt || '';
      image.width = 52;
      image.height = 78;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);

      if (config.gratisLabel) {
        const badge = doc.createElement('span');
        badge.className = 'eantas-upcart-gwp__badge';
        badge.textContent = config.gratisLabel;
        media.appendChild(badge);
      }

      banner.appendChild(media);
    } else {
      const plus = doc.createElement('span');
      plus.className = 'eantas-upcart-gwp__plus';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      banner.appendChild(plus);
    }

    const body = doc.createElement('span');
    body.className = 'eantas-upcart-gwp__body';

    const copy = doc.createElement('span');
    copy.className = 'eantas-upcart-gwp__copy';
    copy.textContent = offer.message || '';
    body.appendChild(copy);

    const cta = doc.createElement('span');
    cta.className = 'eantas-upcart-gwp__cta';
    cta.textContent = config.cta || '';
    body.appendChild(cta);

    banner.appendChild(body);
    banner.addEventListener('click', () => {
      if (typeof window.upcartCloseCart === 'function') {
        window.upcartCloseCart();
      }
    });
    return banner;
  }

  function removeBanners() {
    getSearchRoots().forEach((root) => {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll(`#${BANNER_ID}, [data-eantas-gwp="1"]`).forEach((node) => node.remove());
    });
  }

  function insertBanners(offer) {
    if (!offer) return;
    attachHost();
    getSearchRoots().forEach((root) => {
      if (!root || !root.querySelector) return;
      const header = findMount(root);
      if (!header) return;
      ensureShadowStyles(root);
      const existing = header.parentNode.querySelector(`#${BANNER_ID}`);
      if (existing && existing.dataset.offerKey === offerKey(offer)) return;
      if (existing) existing.remove();
      header.insertAdjacentElement('afterend', buildBanner(ownerDocument(header), offer));
    });
  }

  function applyQty(qty) {
    lastPyjamaQty = qty;
    const offer = nextTier(qty);
    lastOffer = offer;
    if (offer) {
      insertBanners(offer);
    } else {
      removeBanners();
    }
  }

  async function loadCollectionIds() {
    if (collectionIdsLoaded) return;
    collectionIdsLoaded = true;
    const handle = config.collectionHandle || 'schlafkollektion';
    try {
      const response = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!response.ok) {
        collectionIdsLoaded = false;
        return;
      }
      const data = await response.json();
      (data.products || []).forEach((product) => {
        const id = String(product.id || '');
        if (!id || id === giftProductId) return;
        pyjamaIds.add(id);
      });
    } catch (error) {
      collectionIdsLoaded = false;
    }
  }

  async function refreshFromCart(cart) {
    const items = cartItems(cart);
    applyQty(countPyjamas(items));
    await loadCollectionIds();
    applyQty(countPyjamas(items));
  }

  async function refreshFromShopify() {
    if (syncing) return;
    syncing = true;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      await refreshFromCart(await response.json());
    } catch (error) {
      // Keep the last known state if cart.js is briefly unavailable.
    } finally {
      syncing = false;
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => {
      refreshFromShopify();
    }, 80);
  }

  function subscribeUpcart() {
    const api = [
      'upcartSubscribeCartLoaded',
      'upcartSubscribeCartUpdated',
      'upcartSubscribeCartOpened',
      'upcartSubscribeAddedToCart',
      'upcartSubscribeItemRemoved'
    ];

    api.forEach((name) => {
      const fn = window[name];
      if (typeof fn !== 'function') return;
      fn((event) => {
        if (event && event.cart) {
          refreshFromCart(event.cart);
          return;
        }
        scheduleRefresh();
      });
    });
  }

  function waitForUpcartApi() {
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      subscribeUpcart();
      return;
    }

    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (typeof window.upcartSubscribeCartUpdated === 'function') {
        window.clearInterval(timer);
        subscribeUpcart();
        scheduleRefresh();
        return;
      }
      if (tries >= 50) window.clearInterval(timer);
    }, 200);
  }

  function attachHost() {
    const host = document.getElementById('upCart');
    if (!host || host === observedHost) return Boolean(host);
    observedHost = host;
    if (!drawerObserver) {
      drawerObserver = new MutationObserver(() => {
        if (lastOffer) {
          insertBanners(lastOffer);
        } else if (lastPyjamaQty !== null) {
          removeBanners();
        }
      });
    }
    drawerObserver.observe(host, { childList: true, subtree: true });
    return true;
  }

  function observeDrawer() {
    if (attachHost()) return;

    const boot = new MutationObserver(() => {
      if (attachHost()) boot.disconnect();
    });
    boot.observe(document.documentElement, { childList: true, subtree: true });
  }

  function bindThemeCartEvents() {
    ['cart:change', 'cart:updated', 'on:cart:change', 'on:cart:after-merge'].forEach((name) => {
      document.addEventListener(name, scheduleRefresh);
    });
  }

  function patchCartFetch() {
    if (!window.fetch || window.fetch.__eantasGwp) return;
    const originalFetch = window.fetch.bind(window);
    const wrapped = function patchedFetch(input, init) {
      const result = originalFetch(input, init);
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(scheduleRefresh, () => {});
      }
      return result;
    };
    wrapped.__eantasGwp = true;
    window.fetch = wrapped;
  }

  function start() {
    waitForUpcartApi();
    observeDrawer();
    bindThemeCartEvents();
    patchCartFetch();
    scheduleRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
